import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

export interface AlertDialogProps {
  open: boolean;
  title: string;
  description: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmColor?: "primary" | "error" | "warning" | "info" | "success";
}

/**
 * Alert Dialog Component
 * Reusable confirmation dialog with customizable title, description, and buttons
 * Based on GenericAlertModal structure
 */
export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      onBackdropClick={onCancel}
      PaperProps={{
        style: {
          width: "100%",
          maxWidth: "280px",
          display: "flex",
          backgroundColor: "#DED9F8", // Light purple background
          textAlign: "center",
          borderRadius: "28px",
          minHeight: "200px",
        },
      }}
    >
      <DialogContent
        style={{
          textAlign: "left",
          padding: "2.25rem 1.25rem 0.75rem 1.25rem",
        }}
      >
        {title && (
          <Typography variant="headlineMedium" color="#232B36">
            {title}
          </Typography>
        )}
        {description && (
          <DialogContentText variant="bodySmall" color="#232B36">
            {description}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions
        style={{
          paddingRight: "24px",
          paddingBottom: "24px",
          borderTop: "none",
        }}
      >
        {cancelText && (
          <Button
            onClick={onCancel}
            variant="text"
            style={{
              color: "#7262B4",
              textTransform: "capitalize",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          onClick={onConfirm}
          variant="text"
          style={{
            color: "#7262B4",
            textTransform: "capitalize",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
